import React, { createContext, useContext, useEffect, useState } from "react"

export type CoinhallToken = {
    id: string,
    icon?: string
}

const CoinhallTokenContext = createContext<CoinhallToken[]>([])

export const useCoinhallToken = () => useContext(CoinhallTokenContext)

export function CoinhallTokenProvider({ children }: { children: React.ReactNode }) {
    const [tokens, setTokens] = useState<CoinhallToken[]>([])

    const loadTokens = async () => {
        const res = await fetch("https://raw.githubusercontent.com/coinhall/yacar/main/terraclassic/asset.json")
        const json: CoinhallToken[] = await res.json()
        setTokens(json.map(e => ({ icon: e.icon, id: e.id })))
    }

    useEffect(() => {
        loadTokens()
    }, [])

    return <CoinhallTokenContext.Provider value={tokens}>
        {children}
    </CoinhallTokenContext.Provider>
}